"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var react_1 = __importDefault(require("react"));
var Header = function (props) {
    return react_1.default.createElement("div", { className: ['d-flex', props.className].filter(function (c) { return c; }).join(' '), style: { backgroundColor: '#BAE3E1', minHeight: '40px' } },
        react_1.default.createElement("div", { className: "flex-grow-1 d-flex align-items-center" },
            react_1.default.createElement("h6", { style: { color: '#353D3D' }, className: "px-2 m-0" }, props.label)),
        react_1.default.createElement("div", { className: "text-nowrap" }, props.children));
};
exports.Header = Header;
//# sourceMappingURL=Header.js.map